import { render, staticRenderFns } from "./FormDefinitionForm.vue?vue&type=template&id=8ba65efe"
import script from "./FormDefinitionForm.vue?vue&type=script&lang=js"
export * from "./FormDefinitionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ba65efe')) {
      api.createRecord('8ba65efe', component.options)
    } else {
      api.reload('8ba65efe', component.options)
    }
    module.hot.accept("./FormDefinitionForm.vue?vue&type=template&id=8ba65efe", function () {
      api.rerender('8ba65efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/form/FormDefinitionForm.vue"
export default component.exports